import * as Yup from 'yup';

const validateAddCarModal = Yup.object().shape({
  number: Yup.string().required(`Обов'язкове поле`),
  description: Yup.string().required(`Обов'язкове поле`),
});

export default validateAddCarModal;
